import { render, staticRenderFns } from "./after-sale.vue?vue&type=template&id=d4b57c22&scoped=true"
import script from "./after-sale.vue?vue&type=script&lang=ts"
export * from "./after-sale.vue?vue&type=script&lang=ts"
import style0 from "./after-sale.vue?vue&type=style&index=0&id=d4b57c22&prod&scoped=true&lang=css"
import style1 from "./after-sale.vue?vue&type=style&index=1&id=d4b57c22&prod&lang=stylus"
import style2 from "./after-sale.vue?vue&type=style&index=2&id=d4b57c22&prod&module=true&lang=stylus"




function injectStyles (context) {
  
  this["$style"] = (style2.locals || style2)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "d4b57c22",
  null
  
)

export default component.exports